export default __webpack_public_path__ + "static/media/screen4.b9bdef61.jpg";